export default __webpack_public_path__ + "static/Ecologi_Climate_Action_Workforce_Logo_Landscape_White-03dd4ba5b0be9ece13d679156cc62279.svg";